const Report = () =>
  import(
    /* webpackChunkName: "base-info-car-type" */ '@/pages/base-info/car/type/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "base-info-car-type" */ '@/pages/base-info/car/type/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "base-info-car-type" */ '@/pages/base-info/car/type/edit.vue'
  )

export default {
  path: 'type',
  meta: {
    label: 'carFeature',
    auth: 'type'
  },
  component: {
    name: 'Type',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCarType',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'BaseInfoCreateCarType',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'BaseInfoEditCarType',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
